import { Modal } from '@77sol-ui/molecules'
import styled from 'styled-components'

export const ModalContent = styled<any>(Modal.Content)`
  padding-right: ${({ isScrolling }) => (isScrolling ? '8px' : '0px')};
`
